import { render, staticRenderFns } from "./AppButtonIcon.vue?vue&type=template&id=422ced26&scoped=true&"
import script from "./AppButtonIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppButtonIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ced26",
  null
  
)

export default component.exports